import { BlocksViewContainer } from "@pathwright/blocks-engine"
import { ContentViewer } from "../viewer/ContentViewer"

const BlocksContentViewerContainer = (props) => {
  return (
    <BlocksViewContainer {...props}>
      <ContentViewer />
    </BlocksViewContainer>
  )
}

export default BlocksContentViewerContainer
